export const LPL = {
  primary_color: '#0D1D4A',
  primary_gradient: 'linear-gradient(90deg, #C8DEEB 0%, #E9E9E9 100%)',
  secondary_color: '#FFBD9E',
  secondary_gradient: 'linear-gradient(90deg, rgba(237, 107, 47, 0.15) 0%, rgba(237, 107, 47, 0) 100%)',
  //   home_background:
};
